export default __webpack_public_path__ + "static/media/permissions-blocked-safari.6d73a049.svg";